import { Env } from '../../core/env';
import { RecentCheckedItemAction } from '../../core/actions/recent_checked_item/recent_checked_item_action';

document.addEventListener('lazybeforeunveil', (e) => {
  const target = e.target as HTMLElement;
  if (target.id === 'js-recent-checked-item-body') {
    RecentCheckedItemAction.init(Env);
  }
});
